/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoViewsRequest { 
    channelId?: number | null;
    categoryId?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    topN?: number;
    metric?: string | null;
}

